import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import {
  CompanyState,
  UserSettingObject,
  ValuationGridData,
  ValuationPeriodState,
} from "../valuation-page.model";
import { PeriodUserSettingObj } from "@va/core-library/period-filter";
import { ValuationPageDataService } from "../valuation-page-data.service";
import {
  getUserSettingDetails,
  createGridData,
  updateUserSettingDetails,
  getSelectedRatiosId,
  getIsDenomSelected,
  getIsDenomYoySelected,
  getExtraLogDetails,
} from "../valuation-page-utils";
import {
  COMPANY_TAB,
  VALUATION_LOG_ACTION_FEATURES,
  VALUATION_PAGE,
} from "../valuation-page.constant";
import { AppService } from "src/app/app.service";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { LineItemModalComponent } from "src/app/shared/line-item-modal/line-item-modal.component";
@Component({
  selector: "app-valuation-page-company",
  templateUrl: "./valuation-page-company.component.html",
  styleUrls: ["./valuation-page-company.component.scss"],
})
export class ValuationPageCompanyComponent {
  @Input() gridData: ValuationGridData = {};
  @Input() state: CompanyState;
  @Input() isMetaReady = false;
  @Input() currentTicker: string;
  @Input() currentCompany: number;
  @Input() isUserPeriodCalSettingsInProgress = false;
  @Input() highlightGAAP = false;
  @Input() visible = false;
  @Input() apiEP: string = window.apiUrl;

  @Output() saveRatios = new EventEmitter();
  @Output() showSnackBarMessage: EventEmitter<any> = new EventEmitter();
  @Output() onPeriodCalculationChange: EventEmitter<any> = new EventEmitter();
  @Output() onPeriodChange: EventEmitter<any> = new EventEmitter();
  @Output() onCurrencyChange = new EventEmitter();

  ratioLineItemsData: any;
  suggestedRatioLines;
  orderedRatioData;
  isLineItemDataReady = false;
  periodsWithAvailableData;

  currentTabId = COMPANY_TAB.id;
  tabType = "company";
  ratioList: Array<any>;
  orientationValue = "company";

  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  userSettingDetails: UserSettingObject;
  isValuation = true;
  currency: string;
  excelToExportDropdownOptions = [
    {
      label: "Values",
      id: 1,
      disabled: false,
    },
    {
      label: "Excel Add-In Formulas",
      id: 0,
      disabled: false,
    },
  ];
  isExportPopoverVisible = false;

  //loaders
  isUserSettingsInProgress = false;
  currencyUpdating = false;
  isExportInProgress = false;
  isDataInProgress = true;

  isVisibleEditTickerModal = false;
  isVisibleEditLiModal = false;
  leftModalDataReady = false;

  lineItemMaxLimit = 20;
  selectedLineItemCount = 0;
  selectedRatioId;
  lineItemsModal: NzModalRef;

  constructor(
    private dataService: ValuationPageDataService,
    private appService: AppService,
    private modalService: NzModalService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.state && changes.state.currentValue.currency) {
      this.currency = changes.state.currentValue.currency;
    }

    // update ratio line item data on ticker change
    if (
      changes.currentTicker &&
      changes.currentTicker.currentValue &&
      changes.currentTicker.currentValue !== changes.currentTicker.previousValue
    ) {
      this.getRatioLineItemData(changes.currentTicker.currentValue);
      this.getPeriodsWithAvailableData([changes.currentTicker.currentValue]);
    }

    if (changes.state && changes.state.currentValue.ratios) {
      const orderedRatioItems = this.orderedRatioData
        ? this.orderedRatioData.map(
            (item) => item.uniquesliid || item.sliid || item.sli_id,
          )
        : undefined;
      this.gridData = createGridData(
        changes.state.currentValue,
        orderedRatioItems,
      );
      this.ratioList = this.createCompanyRatioList(this.gridData);
      this.fetchAndHandleValuationData(this.gridData.ratios, this.state);
      this.selectedLineItemCount = (
        getSelectedRatiosId(this.state.ratios.ratio_details) || []
      ).length;
    }

    if (
      changes.isMetaReady &&
      changes.isMetaReady.currentValue &&
      changes.isMetaReady.currentValue !== changes.isMetaReady.previousValue
    ) {
      if (
        this.state.ratios &&
        this.state.period &&
        this.state.currency &&
        this.state.ticker_info
      ) {
        this.userSettingDetails = getUserSettingDetails({
          tabType: this.currentTabId,
          currentTicker: this.currentTicker,
          ratios: this.state.ratios,
          periods: this.state.period,
          tickers: this.state.ticker_info,
          currency: this.state.currency,
        });
      }

      if (this.state && this.state.ratios) {
        this.selectedRatioId =
          getSelectedRatiosId(this.state.ratios.ratio_details) || [];
        this.selectedLineItemCount = this.selectedRatioId.length;
      }
    }
  }

  /**
   * It call the get_std_line_items api and formats the response
   */
  getRatioLineItemData(ticker) {
    this.isLineItemDataReady = false;
    this.dataService.getStdLineItems([ticker]).subscribe((res) => {
      this.ratioLineItemsData = res.data.filter(
        (d) => d.tab_short_name === "SL" || d.tab_short_name === "VR",
      );
      if (this.state && this.state.ratios) {
        this.selectedRatioId =
          getSelectedRatiosId(this.state.ratios.ratio_details) || [];
        this.selectedLineItemCount = this.selectedRatioId.length;
      }
      const _suggestedLines: Array<any> = res.data.filter(
        (d) => d.tab_short_name === "SL",
      );
      this.suggestedRatioLines = _suggestedLines.length
        ? _suggestedLines[0].tab_sli_data.map((l) => {
            return {
              ...l,
              disabled: false,
              label: l.name,
              isLeaf: true,
              level: 2,
              header: false,
              sliid: l.sli_id,
              line_count: l.line_count,
              id: l.uniquesliid,
            };
          })
        : [];

      if (this.suggestedRatioLines.length > 0) {
        this.suggestedRatioLines = [
          {
            suggestion_header: "Suggestions: ",
            isLeaf: true,
            disabled: true,
          } as any,
        ]
          .concat(this.suggestedRatioLines)
          .concat({
            suggestion_footer: "Selected Line Items",
            isLeaf: true,
            disabled: true,
          } as any);
      } else {
        this.suggestedRatioLines = [
          {
            suggestion_header: "No suggestion found ",
            isLeaf: true,
            disabled: true,
          } as any,
        ]
          .concat(this.suggestedRatioLines)
          .concat({
            suggestion_footer: "Selected Line Items",
            isLeaf: true,
            disabled: true,
          } as any);
      }
      this.isLineItemDataReady = true;
    });
  }

  /**
   * This function is fired when the save ratio event is emitted from
   * the ratio filter component.
   * This updates the ratios list in the state and calls the saveusersetting api to save it.
   * It calls the snackbar with appropriated added and removed ratios.
   * @param e ratio data when the event is emitted
   */
  handleRatios(e) {
    const removedRatio = [];
    const addedRatio = [];
    this.isUserSettingsInProgress = true;
    this.snackbarInfo.message = "";
    e.include.forEach((data, index) => {
      this.state.ratios.include[index]["selected"] = data["checked"];
    });
    e.ratios.forEach((data, index) => {
      if (data["selected"] && !data["checked"]) {
        removedRatio.push(data["label"]);
      }
      if (!data["selected"] && data["checked"]) {
        addedRatio.push(data["label"]);
      }
      this.state.ratios.ratio_details[index]["ratio"]["selected"] =
        data["checked"];
    });

    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      {
        selectedRatios: getSelectedRatiosId(this.state.ratios.ratio_details),
        isDenomSelected: getIsDenomSelected(this.state.ratios.include),
        isDenomYoySelected: getIsDenomYoySelected(this.state.ratios.include),
      },
    );

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.saveRatios.emit({
            ratios: this.state.ratios.ratio_details,
            include: this.state.ratios.include,
          });

          if (addedRatio.length) {
            this.snackbarInfo.message = `${addedRatio} have been added to the table.`;
          }
          if (removedRatio.length) {
            this.snackbarInfo.message += ` ${removedRatio} have been removed from the table.`;
          }

          if (this.snackbarInfo.message) {
            this.snackbarInfo.type = "success";
            this.showSnackBarMessage.emit(this.snackbarInfo);
          }

          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.updateRatio,
            getExtraLogDetails(
              this.currentCompany,
              COMPANY_TAB.label,
              this.userSettingDetails,
              this.state.period_calculation,
            ),
            "",
            VALUATION_PAGE,
          );
        }
        this.isUserSettingsInProgress = false;
      });
  }

  /**
   * This function is fired when the save currency event is fired from the currency filter component.
   * It updates the currency in the state and calls the saveusersettings api to save it.
   * @param item selected currency
   */
  updateCurrency(item) {
    this.currencyUpdating = true;
    this.isUserSettingsInProgress = true;
    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      {
        currency: item,
      },
    );

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.onCurrencyChange.emit({
            item,
            magMsg: response["magnitude_message"],
          });
          this.currencyUpdating = false;

          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.updateCurrency,
            getExtraLogDetails(
              this.currentCompany,
              COMPANY_TAB.label,
              this.userSettingDetails,
              this.state.period_calculation,
            ),
            "",
            VALUATION_PAGE,
          );
        }
        this.isUserSettingsInProgress = false;
      });
  }

  /**
   * It is used to call the dataservice to get the data for company tab
   * and sets the griddata with the response data.
   * @param ratios ratio list selected to get data
   * @param state current state of company tab
   */
  fetchAndHandleValuationData(ratios: Array<string>, state: CompanyState) {
    this.isDataInProgress = true;
    this.dataService
      .getValuationData(ratios, this.gridData, state, "company")
      .subscribe((gridData: ValuationGridData) => {
        this.gridData = gridData;
        this.isDataInProgress = false;
        this.appService.logUserAction(
          {},
          this.currentTicker,
          "",
          VALUATION_LOG_ACTION_FEATURES.dataCall,
          {
            ...getExtraLogDetails(
              this.currentCompany,
              COMPANY_TAB.label,
              this.userSettingDetails,
              this.state.period_calculation,
            ),
          },
          "",
          VALUATION_PAGE,
        );
      });
  }

  /**
   * It emits `onPeriodCalculationChange` with selected radio values
   * @param {{ntmStmValue: string, calendariozationValue: string}} value: selected radio values from period calculation popup
   */
  handlePeriodCalculationApply(value) {
    this.onPeriodCalculationChange.emit({
      value,
      userSettingDetails: this.userSettingDetails,
    });
  }

  /**
   * It is used to create an array of objects of the ratios
   * where each obj contains the group of ratio and it's denominators grouped toghther
   * @param _gridData - data state of the grid
   */
  createCompanyRatioList(_gridData: ValuationGridData) {
    const _ratioList = [];
    let r = {};
    for (let i = 0; i < _gridData.ratios.length; i++) {
      if (!_gridData.ratios[i].startsWith("#")) {
        r = {};
        //r[_gridData.ratios[i]] = {};
        r["ratio"] = _gridData.ratios[i];
        _ratioList.push(r);
      } else {
        if (_gridData.ratios[i].includes("denom_yoy")) {
          _ratioList[_ratioList.length - 1]["denom_yoy"] = _gridData.ratios[i];
        } else {
          _ratioList[_ratioList.length - 1]["denom"] = _gridData.ratios[i];
        }
      }
    }
    return _ratioList;
  }

  /**
   * Executes on click of Period filter popup's Apply button.
   * It posts the selected period setting to user setting api
   * It emits `onPeriodChange` with selected periodData
   * @param {{updatedPeriodData: ValuationPeriodState, periodUserSettingData: PeriodUserSettingObj}} periodData: selected values from period filter popup
   */
  handlePeriodApply(periodData: {
    updatedPeriodData: ValuationPeriodState;
    periodUserSettingData: PeriodUserSettingObj;
  }) {
    const { updatedPeriodData, periodUserSettingData } = periodData;

    this.isUserSettingsInProgress = true;

    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      periodUserSettingData,
    );

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.onPeriodChange.emit(updatedPeriodData);
          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.updatePeriod,
            getExtraLogDetails(
              this.currentCompany,
              COMPANY_TAB.label,
              this.userSettingDetails,
              this.state.period_calculation,
            ),
            "",
            VALUATION_PAGE,
          );
        }
        this.isUserSettingsInProgress = false;
      });
  }

  /**
   * Executes on click of export dropdown list item
   * It closes the dropdown on selecting list items. Also one can update the loader status when excel to export action is in progress
   * @param {id} number Indicates the id of selected list item from optionList
   */
  handleETEListItemClick(id) {
    this.isExportInProgress = true;
    let extra = {};
    extra = {
      export_type: id,
      template_type: "valuation company",
    };

    this.appService
      .exportToExcel("valuation company", this.currentTicker, extra)
      .subscribe((res) => {
        if (res["status"] === "success") {
          const fileName = res["filename"];
          const trackerId = res["trackerid"];
          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.export,
            {
              ...getExtraLogDetails(
                this.currentCompany,
                COMPANY_TAB.label,
                this.userSettingDetails,
                this.state.period_calculation,
              ),
              beginning_state_referrer: "Valuation Company page",
              export_type: 1,
              tracker_id: trackerId,
              file_name: fileName,
            },
            "",
            VALUATION_PAGE,
          );
        }
        this.isExportInProgress = false;
      });

    // close export to excel popover
    this.isExportPopoverVisible = false;
  }

  /**
   * It executes on the search and selection of line item
   * It adds this line item to existing list
   * @param {object} e: selected line item
   */
  onSearchedLi(e) {
    if (!e) {
      return;
    }

    const selectedRatioLineIds = this.state.ratios
      ? getSelectedRatiosId(this.state.ratios.ratio_details)
      : [];

    // check if already existing line items are more or equal to max limit. If yes don't add new item
    if (selectedRatioLineIds.length >= this.lineItemMaxLimit) {
      return;
    }

    const value = { ...e, parent: undefined, sliid: e.sliid || e.sli_id };
    const alreadyExist = selectedRatioLineIds.includes(value.sliid);

    if (!alreadyExist) {
      this.isUserSettingsInProgress = true;
      const allSelectedRatiosId = selectedRatioLineIds.concat(value.sliid);

      //update the selected check of ratio item
      const updatedRatios = this.state.ratios.ratio_details.map((item) => {
        const ratioItem = item.ratio;
        if (ratioItem.usliid === value.sliid) {
          item.ratio.selected = true;
        }
        return item;
      });

      this.userSettingDetails = updateUserSettingDetails(
        this.userSettingDetails,
        {
          selectedRatios: allSelectedRatiosId,
        },
      );
      this.dataService
        .saveUserSettings(this.userSettingDetails)
        .subscribe((response: { status: string; data }) => {
          if (response.status === "success") {
            this.saveRatios.emit({
              ratios: updatedRatios,
              include: this.state.ratios.include,
            });

            if (updatedRatios) {
              this.selectedRatioId = getSelectedRatiosId(updatedRatios) || [];
              this.selectedLineItemCount = this.selectedRatioId.length;
              this.orderedRatioData = this.orderedRatioData
                ? this.orderedRatioData.concat(value)
                : undefined;
            }

            this.snackbarInfo.message = `${value.label} has been added to the table`;
            this.snackbarInfo.type = "success";
            this.showSnackBarMessage.emit(this.snackbarInfo);
            (error) => {
              console.error(error);
            };
            this.appService.logUserAction(
              {},
              this.currentTicker,
              "",
              VALUATION_LOG_ACTION_FEATURES.updateRatio,
              getExtraLogDetails(
                this.currentCompany,
                COMPANY_TAB.label,
                this.userSettingDetails,
                this.state.period_calculation,
              ),
              "",
              VALUATION_PAGE,
            );
            this.isUserSettingsInProgress = false;
          }
        });
    } else {
      this.leftModalDataReady = true;
      this.snackbarInfo.message = "This line item is already present.";
      this.snackbarInfo.type = "info";
      this.showSnackBarMessage.emit(this.snackbarInfo);
    }
  }

  /**
   * It adds line items selected from the edit modal to the list
   * @param {object} data: selected data from line item modal
   */
  updateEditModalLineItems(data) {
    const { modalData, selectedRatioDenomItems = [] } = data;
    this.orderedRatioData = [...modalData];
    this.isUserSettingsInProgress = true;
    const selectedRatioItems = modalData.map(
      (item) => item.uniquesliid || item.sliid || item.sli_id,
    );
    const isDenomSelected = !!(
      selectedRatioDenomItems && selectedRatioDenomItems.includes("denom")
    );
    const isDenomYoySelected = !!(
      selectedRatioDenomItems && selectedRatioDenomItems.includes("denom_yoy")
    );

    //update the selected check of ratio item
    const updatedRatios = this.state.ratios.ratio_details.map((item) => {
      const ratioItem = item.ratio;
      item.ratio.selected = selectedRatioItems.includes(ratioItem.usliid);
      return item;
    });

    const updatedIncludes = this.state.ratios.include.map((item) => ({
      ...item,
      selected: selectedRatioDenomItems.includes(item.name),
    }));

    this.userSettingDetails = updateUserSettingDetails(
      this.userSettingDetails,
      {
        selectedRatios: selectedRatioItems,
        isDenomSelected,
        isDenomYoySelected,
      },
    );

    this.lineItemsModal.destroy();

    this.dataService
      .saveUserSettings(this.userSettingDetails)
      .subscribe((response: { status: string; data }) => {
        if (response.status === "success") {
          this.saveRatios.emit({
            ratios: updatedRatios,
            include: updatedIncludes,
          });

          if (updatedRatios) {
            this.selectedRatioId = getSelectedRatiosId(updatedRatios) || [];
            this.selectedLineItemCount = this.selectedRatioId.length;
          }

          (error) => {
            console.error(error);
          };
          this.appService.logUserAction(
            {},
            this.currentTicker,
            "",
            VALUATION_LOG_ACTION_FEATURES.updateRatio,
            getExtraLogDetails(
              this.currentCompany,
              COMPANY_TAB.label,
              this.userSettingDetails,
              this.state.period_calculation,
            ),
            "",
            VALUATION_PAGE,
          );
          this.isUserSettingsInProgress = false;
        }
      });
  }

  /**
   * It executes on the click of Edit button of lien item filter
   * It creates the Line item modal withe required information and opens it.
   */
  handleEditLineItemsButtonClick() {
    let selectedRatioItems = [];
    if (this.orderedRatioData) {
      selectedRatioItems = this.orderedRatioData;
    } else {
      selectedRatioItems = this.state.ratios.ratio_details
        .filter((item) => item.ratio.selected)
        .map((el) => {
          const sliId = el.ratio.usliid || el.ratio.sliid || el.ratio.el.sli_id;
          return {
            ...el.ratio,
            sli_id: sliId,
            name: el.ratio.label,
            is_valuation_ratio: true,
          };
        });
    }

    this.lineItemsModal = this.modalService.create({
      nzTitle: "Edit Line Items",
      nzOkLoading: true,
      nzContent: LineItemModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addColTableData: selectedRatioItems,
        stdLineItems: this.ratioLineItemsData,
        max: this.lineItemMaxLimit,
        maxHeight: "290px",
        selectedPeriod: [],
        tickers: [this.currentTicker],
        createSource: "consensus",
        ratioDenomData: this.state.ratios.include,
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.lineItemsModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          nzClassName: (data) => {
            return data.modalData.length > data.max ? "disable" : "";
          },
          onClick: (data): void => {
            this.updateEditModalLineItems(data);
          },
          disabled: (data) => {
            return (
              data.modalData.length > data.max || data.modalData.length === 0
            );
          },
        },
      ],
    });
  }

  getPeriodsWithAvailableData(tickerIds) {
    this.appService
      .getPeriodsWithData(tickerIds)
      .subscribe((response: { status; dataAvailable }) => {
        if (response.status === "success") {
          this.periodsWithAvailableData = response.dataAvailable;
        }
      });
  }
}
